import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Row,
} from "reactstrap";
import { DataModel } from "../models/data.model";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { MAIN_LANDING_PAGE } from "../constants";
import { trackButtonClick } from "../application-insights-config";

interface Props {
  model: DataModel;
  isOpen: boolean;
  toggle: () => void;
  setForecastName: (name: string) => void;
}

export const ShareModal = ({
  model,
  isOpen,
  toggle,
  setForecastName,
}: Props) => {
  const shareTitle = "HerdPlan forecast";
  const body = "Check out this tool for health risk management on farm";
  const url = window.location.origin + process.env.PUBLIC_URL;
  const shareUrl = decodeURIComponent(url ?? MAIN_LANDING_PAGE);

  const onShare = (type: string) => () => trackButtonClick("click_share", type);

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Share this tool</ModalHeader>
      <ModalBody>
        <p>
          If you liked this tool or found it useful, please consider sharing it
          with a friend, colleague or your vet!
        </p>
        <br />
        <span>Click a button to share it:</span>
        <Row className="w-75 m-auto">
          <Col style={{ margin: 8 }}>
            <FacebookShareButton url={shareUrl} htmlTitle="Facebook">
              <FacebookIcon size={32} round onClick={onShare("facebook")} />
            </FacebookShareButton>
          </Col>

          <Col style={{ margin: 8 }}>
            {/* TODO: URL is text, not a link */}
            <EmailShareButton
              url={shareUrl}
              subject={shareTitle}
              body={body}
              htmlTitle="Email"
            >
              <EmailIcon size={32} round onClick={onShare("email")} />
            </EmailShareButton>
          </Col>

          <Col style={{ margin: 8 }}>
            <WhatsappShareButton
              url={shareUrl}
              title={shareTitle}
              separator=": "
              htmlTitle="WhatsApp"
            >
              <WhatsappIcon size={32} round onClick={onShare("whats_app")} />
            </WhatsappShareButton>
          </Col>

          <Col style={{ margin: 8 }}>
            <TwitterShareButton
              url={shareUrl}
              title={shareTitle}
              htmlTitle="X, formerly known as Twitter"
            >
              <XIcon size={32} round onClick={onShare("twitter")} />
            </TwitterShareButton>
          </Col>
        </Row>
        <span>Or copy a link:</span>
        <Row className="w-75 m-auto">
          <Col style={{ margin: 8 }} className="hand">
            <FontAwesomeIcon
              id="copy-link"
              icon={faCopy}
              size="xl"
              transform={"grow-2.5"}
              title="Copy"
              onClick={() => {
                navigator?.clipboard?.writeText(shareUrl);
                toast.success("Link copied!");
                onShare("copy_link")();
              }}
            />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Close
        </Button>
        <div className="flex-grow-1" />
      </ModalFooter>
    </Modal>
  );
};
